import React from 'react';
import { useState } from "react";
import {RiFileUserFill} from 'react-icons/ri';
import '../../../CSS/Dashboard/dashboard.scss';
import TextInput from "../Components/textInput";
const DashboardPage = ()=> {
  const [logoname,setLogoName] = useState("");
  const [adminname,setAdminName] = useState("");

  const handleLogoNameSubmit = (event)=>{
    event.preventDefault();
    // console.log(logoname);
  }

  const handleAdminNameSubmit = (event)=>{
    event.preventDefault();
    console.log(adminname);
  }
return (
<div className="dashboard-page">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h2>Dashboard Page</h2>
      </div>
    </div>
    <div className="row mt-5">
      <div className="col-md-6">
      <TextInput
          title = "Logo Name"
          handleInputSubmit = {handleLogoNameSubmit}
          setInputValue = {setLogoName}
          inputValue = {logoname}
        />
      </div>
      <div className="col-md-6">
        <TextInput
          title = "Admin Name"
          handleInputSubmit = {handleAdminNameSubmit}
          setInputValue = {setAdminName}
          inputValue = {adminname}
        />
      </div>
    </div>
    <div className="row mt-5">
      <div className="col-md-12">
      <div className="card col-md-12">
        <div className="card-body pt-5 pb-5">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <h4>Total Visit</h4>
              </div>
              <div className="row">
                <h4>100</h4>
              </div>
            </div>
            <div className="col-md-6">
              <RiFileUserFill className="user-icon"/>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
);
}

export default DashboardPage;